export const   toggleFavorite= '[FAVORITE] TOGGLE'
export const   favoriteSuccess= '[FAVORITE] SUCCESS'
export const   favoriteError= '[FAVORITE] ERROR'
export const   unFavoriteSuccess= '[UN-FAVORITE] SUCCESS'
export const   unFavoriteError= '[UN-FAVORITE] ERROR'
export const   favoritesSet= '[FAVORITE] SET'
export const   favoritesReset= '[FAVORITE] RESET'
